<template>
  <div class="min-h-screen bg-white">
    <!-- KB Hero Header -->
    <section class="bg-slate-900 py-16 relative overflow-hidden text-white">
      <div class="absolute inset-0 bg-red-600/10 -skew-y-3 origin-top-left"></div>
      <div class="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <h1 class="text-3xl md:text-5xl font-bold tracking-tight mb-4">Fire Safety Knowledge Base</h1>
        <p class="text-slate-300 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
          Expert guides, installation manuals, and Civil Defense compliance regulations for Qatar.
        </p>
      </div>
    </section>

    <!-- Articles List -->
    <main class="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div v-if="articles && articles.length > 0" class="space-y-6">
        <NuxtLink 
          v-for="article in articles" 
          :key="article.id" 
          :to="`/knowledge-base/${article.slug}`"
          class="block group bg-white rounded-xl p-6 border border-slate-100 hover:border-red-200 hover:shadow-xl hover:shadow-red-900/5 transition-all duration-300"
        >
          <div class="flex items-center gap-2 text-[10px] font-bold text-red-600 uppercase tracking-widest mb-3">
            <span>{{ article.category || 'Guide' }}</span>
            <span class="w-1 h-1 rounded-full bg-slate-300"></span>
            <span class="text-slate-400">{{ new Date(article.updatedAt || article.createdAt).toLocaleDateString() }}</span>
          </div>
          <h2 class="text-xl md:text-2xl font-bold text-slate-900 group-hover:text-red-600 transition-colors mb-2">
            {{ article.title }}
          </h2>
          <p class="text-slate-500 text-sm leading-relaxed line-clamp-2">
            {{ article.excerpt || article.description }}
          </p>
          <div class="mt-4 flex items-center text-xs font-bold text-slate-900 uppercase tracking-widest group-hover:text-red-600 transition-colors">
            Read Article <span class="ml-2 transition-transform group-hover:translate-x-1">&rarr;</span>
          </div>
        </NuxtLink>
      </div>
      
      <div v-else class="text-center py-20">
        <h2 class="text-xl font-bold text-slate-900">Knowledge Base is being updated.</h2>
        <p class="text-slate-500 mt-2">Check back soon for expert fire safety guides.</p>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { useAsyncData, useSeoMeta } from '#app'

const { data: articles } = await useAsyncData('knowledge-base-index', () => {
  return $fetch('/api/knowledge-base')
})

useSeoMeta({
  title: 'Fire Safety Knowledge Base | Expert Guides & Regulations Qatar',
  description: 'Read our expert articles on fire safety compliance, CCTV installation guides, and Civil Defense regulations in Doha, Qatar.'
})
</script>
